import SimFallbackHistory from 'components/SimFallbackHistory/SimFallbackHistory';
import SimProfileHistoryPanel from 'components/SimProfileHistoryPanel/SimProfileHistoryPanel';
import SimProfiles from 'components/SimProfiles/SimProfiles';
import { useIsEuiccSim } from 'hooks';
import { type FC } from 'react';

interface ProfilesViewProps {
  hologramSimId?: HologramSimId;
  simDetailBaseUrl: string;
}

const SimProfilesView: FC<ProfilesViewProps> = ({ hologramSimId, simDetailBaseUrl }) => {
  const { showEuiccInfo } = useIsEuiccSim(hologramSimId);

  return (
    <>
      <SimProfiles hologramSimId={hologramSimId} simDetailBaseUrl={simDetailBaseUrl} />
      {showEuiccInfo && <SimFallbackHistory hologramSimId={hologramSimId} />}
      {showEuiccInfo && <SimProfileHistoryPanel hologramSimId={hologramSimId} />}
    </>
  );
};

export default SimProfilesView;
